import './index.css'


// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-muti-left/style/index.js